import { z } from 'zod'

import { useLocale } from '../translate'

export const useZod = () => {
  useLocale()

  return z
}
